import { Temporal } from 'temporal-polyfill';
import { z } from 'zod';

import { dayOfWeekSchema } from './meeting-block.js';

export const timeSlotSchema = z.object({
  day: dayOfWeekSchema,
  startPlainTime: z.instanceof(Temporal.PlainTime),
  duration: z.instanceof(Temporal.Duration),
  popularity: z.number().int(),
});
export type TimeSlot = z.infer<typeof timeSlotSchema>;

export const updateTimeSlotsOptionsSchema = z.array(timeSlotSchema);
export type UpdateTimeSlotsOptions = z.infer<typeof updateTimeSlotsOptionsSchema>;
